import firebase from 'firebase/app';
import 'firebase/firestore';

const firestore = () => firebase.firestore();

firestore.doc = path => firebase.firestore().doc(path);

firestore.collection = path => firebase.firestore().collection(path);

firestore.getDocument = doc => doc.get();

firestore.getCollection = collection => collection.get();

firestore.addDocument = (collection, data) => collection.add(data);

firestore.setDocument = (doc, data, options) => doc.set(data, options);

firestore.deleteDocument = doc => doc.delete();

firestore.updateDocument = (doc, data) => doc.update(data);

firestore.runTransaction = updateFunction => firebase.firestore().runTransaction(updateFunction);

firestore.batch = () => firebase.firestore().batch();

firestore.FieldValue = firebase.firestore.FieldValue;

export default firestore;
